import { useMemo } from 'react';
import useSWR from 'swr';

import apiRequest from '@/services/apiRequest';
import { IMapboxPlacesResponse } from '@/services/types/mapbox/mapboxApi';

import { getMapboxSessionToken, MAPBOX_BASE_URL, MAPBOX_TOKEN } from './useMapboxQuery';

export const useRetrieveMapboxPlace = (mapboxId?: string) => {
  const url = useMemo(() => {
    if (!mapboxId || typeof mapboxId !== 'string') return null;
    return `${MAPBOX_BASE_URL}/search/searchbox/v1/retrieve/${mapboxId}`;
  }, [mapboxId]);

  const { data, error } = useSWR(
    url,
    async (requestUrl: string) => {
      try {
        return await apiRequest<IMapboxPlacesResponse>({
          url: requestUrl,
          params: {
            access_token: MAPBOX_TOKEN,
            session_token: getMapboxSessionToken(true),
          },
        });
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Mapbox retrieve failed:', err);
        return null;
      }
    },
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    },
  );

  return {
    data,
    error,
    place: data?.features?.[0] ?? null,
  };
};
